var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z",
    fill: "#4361EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1.55228 7 2 6.55228 2 6C2 5.44772 1.55228 5 1 5C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7Z",
    fill: "#4361EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1.55228 12 2 11.5523 2 11C2 10.4477 1.55228 10 1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447715 12 1 12Z",
    fill: "#4361EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 5H4.94C4.42085 5 4 5.42085 4 5.94V6.06C4 6.57915 4.42085 7 4.94 7H17.06C17.5791 7 18 6.57915 18 6.06V5.94C18 5.42085 17.5791 5 17.06 5Z",
    fill: "#4361EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 10H4.94C4.42085 10 4 10.4209 4 10.94V11.06C4 11.5791 4.42085 12 4.94 12H17.06C17.5791 12 18 11.5791 18 11.06V10.94C18 10.4209 17.5791 10 17.06 10Z",
    fill: "#4361EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 0H4.94C4.42085 0 4 0.420852 4 0.94V1.06C4 1.57915 4.42085 2 4.94 2H17.06C17.5791 2 18 1.57915 18 1.06V0.94C18 0.420852 17.5791 0 17.06 0Z",
    fill: "#4361EE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterr);
export default __webpack_public_path__ + "static/media/Filterr.9ed27330e7df716f0534ff33645e7cbe.svg";
export { ForwardRef as ReactComponent };